import React, { Component } from "react";

export default class LanguageComprehension extends Component {
  render() {
    var {
      comprehension_question_1,
      comprehension_question_2,
      comprehension_question_3,
      comprehension_question_4,
      comprehension_question_5,
      comprehension_question_6,
      comprehension_question_7,
      comprehension_question_8,
      language_comprehension_score,
      comprehension_question_checkbox_1,
      comprehension_question_checkbox_2,
      comprehension_question_checkbox_3,
      comprehension_question_checkbox_4,
      comprehension_question_checkbox_5,
      comprehension_question_checkbox_6,
      comprehension_question_checkbox_7,
      comprehension_question_checkbox_8,
    } = this.props.data;
    return (
      <div className="row p-3 border border-dark bg-white">
        <div className="col-lg-12">
          <div className="row mt-4">
            <div className="col-lg-6">
              <div className="d-flex mb-3">
                <span className="fs-19">1. An insect </span>{" "}
              </div>
              <input
                value={comprehension_question_1}
                name="comprehension_question_1"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex mb-3">
                <span className="fs-19">2. Something a carpenter uses </span>{" "}
              </div>
              <input
                value={comprehension_question_2}
                name="comprehension_question_2"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex mb-3">
                <span className="fs-19">3. Something with feathers </span>{" "}
              </div>
              <input
                value={comprehension_question_3}
                name="comprehension_question_3"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex mb-3">
                <span className="fs-19">4. A place to sleep </span>{" "}
              </div>
              <input
                value={comprehension_question_4}
                name="comprehension_question_4"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex mb-3">
                <span className="fs-19">5. Something you wear </span>{" "}
              </div>
              <input
                value={comprehension_question_5}
                name="comprehension_question_5"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex mb-3">
                <span className="fs-19">6. Something you play </span>{" "}
              </div>
              <input
                value={comprehension_question_6}
                name="comprehension_question_6"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex mb-3">
                <span className="fs-19">7. Something used to cut wood </span>{" "}
              </div>
              <input
                value={comprehension_question_7}
                name="comprehension_question_7"
                type="text"
                className="ecas-input-field"
              />
            </div>
            <div className="col-lg-6">
              <div className="d-flex mb-3">
                <span className="fs-19">8. An animal that lives in water</span>{" "}
              </div>
              <input
                value={comprehension_question_8}
                name="comprehension_question_8"
                type="text"
                className="ecas-input-field"
              />
            </div>
          </div>
          <hr style={{ marginBottom: 29 }} />
          <div className="pl-0 col-lg-6 text-left">
            <span className="fs-19">Score (0-8) </span>
            <input
              type="number"
              name="language_comprehension_score"
              readOnly=""
              className="ecas-input-field"
              placeholder="Score"
              value={language_comprehension_score}
            />
          </div>
        </div>
      </div>
    );
  }
}
